(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-clients-say"] && !Shopify.designMode) return;
  try {
    
  const swiper = new Swiper('.mySwiper', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    breakpoints: {
      768: {
        slidesPerView: 1
      },
      1024: {
        slidesPerView: 1
      },
      1199:{
        slidesPerView:1
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electro-marquee-ticker"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tickers = document.querySelectorAll('[data-electro-ticker]');
    if (!tickers.length) return;

    tickers.forEach((ticker) => {
      const track = ticker.querySelector('[data-animate-track]');
      if (!track) return;

      const pauseOnHover = ticker.dataset.pauseOnHover === 'true';
      if (!pauseOnHover) return;

      const pause = () => {
        track.style.animationPlayState = 'paused';
      };

      const resume = () => {
        track.style.animationPlayState = 'running';
      };

      ticker.addEventListener('mouseenter', pause);
      ticker.addEventListener('mouseleave', resume);
      ticker.addEventListener('focusin', pause);
      ticker.addEventListener('focusout', resume);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electro-media-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseVideoSource = (raw) => {
      const url = String(raw || '').trim();
      if (!url) return null;
      try {
        const u = new URL(url, window.location.href);
        const host = u.hostname.replace(/^www\./, '');

        if (host === 'youtu.be') {
          const id = u.pathname.split('/').filter(Boolean)[0];
          return id ? { kind: 'youtube', id } : null;
        }
        if (host.includes('youtube.com') || host === 'm.youtube.com') {
          if (u.pathname.startsWith('/embed/')) {
            const id = u.pathname.split('/')[2];
            return id ? { kind: 'youtube', id } : null;
          }
          if (u.pathname.startsWith('/shorts/')) {
            const id = u.pathname.split('/')[2];
            return id ? { kind: 'youtube', id } : null;
          }
          const v = u.searchParams.get('v');
          if (v) return { kind: 'youtube', id: v };
        }
        if (host.includes('vimeo.com')) {
          const m = u.pathname.match(/\/(?:video\/)?(\d+)/);
          if (m) return { kind: 'vimeo', id: m[1] };
        }

        return { kind: 'direct', url: u.href };
      } catch {
        return { kind: 'direct', url };
      }
    };

    const clearSlot = (slot) => {
      if (!slot) return;
      slot.querySelectorAll('iframe, video').forEach((el) => {
        if (el.tagName === 'VIDEO') {
          el.pause();
          el.removeAttribute('src');
          el.load();
        }
        el.remove();
      });
      slot.innerHTML = '';
    };

    const closeShell = (shell, options = {}) => {
      if (!shell || shell.hidden) return;
      const wrap = shell.closest('.electro-media-carousel__media-wrap');
      const slot = wrap?.querySelector('[data-emc-player-slot]');
      const playBtn = wrap?.querySelector('.electro-media-carousel__play[data-emc-video-url]');
      clearSlot(slot);
      shell.hidden = true;
      playBtn?.setAttribute('aria-expanded', 'false');
      if (options.focusPlay) playBtn?.focus({ preventScroll: true });
    };

    const openInlinePlayer = (playBtn) => {
      const raw = playBtn.getAttribute('data-emc-video-url');
      const wrap = playBtn.closest('.electro-media-carousel__media-wrap');
      const shell = wrap?.querySelector('[data-emc-player-shell]');
      const slot = wrap?.querySelector('[data-emc-player-slot]');
      if (!shell || !slot) return;

      document.querySelectorAll('[data-emc-player-shell]').forEach((s) => {
        if (s !== shell) closeShell(s);
      });

      clearSlot(slot);
      const src = parseVideoSource(raw);
      if (!src) return;

      if (src.kind === 'youtube') {
        const iframe = document.createElement('iframe');
        iframe.setAttribute(
          'src',
          `https://www.youtube-nocookie.com/embed/${encodeURIComponent(src.id)}?autoplay=1&playsinline=1&rel=0`
        );
        iframe.setAttribute('title', 'YouTube video');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute(
          'allow',
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
        );
        slot.appendChild(iframe);
      } else if (src.kind === 'vimeo') {
        const iframe = document.createElement('iframe');
        iframe.setAttribute(
          'src',
          `https://player.vimeo.com/video/${encodeURIComponent(src.id)}?autoplay=1&playsinline=1`
        );
        iframe.setAttribute('title', 'Vimeo video');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        slot.appendChild(iframe);
      } else {
        const video = document.createElement('video');
        video.setAttribute('controls', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('preload', 'metadata');
        video.src = src.url;
        video.autoplay = true;
        slot.appendChild(video);
      }

      shell.hidden = false;
      playBtn.setAttribute('aria-expanded', 'true');
      const closeBtn = shell.querySelector('[data-emc-video-close]');
      closeBtn?.focus({ preventScroll: true });
    };

    const closeInlinePlayer = (closeBtn) => {
      const shell = closeBtn.closest('[data-emc-player-shell]');
      closeShell(shell, { focusPlay: true });
    };

    document.addEventListener('click', (e) => {
      const playBtn = e.target.closest('.electro-media-carousel__play[data-emc-video-url]');
      if (playBtn) {
        e.preventDefault();
        openInlinePlayer(playBtn);
        return;
      }
      const closeBtn = e.target.closest('[data-emc-video-close]');
      if (closeBtn) {
        e.preventDefault();
        closeInlinePlayer(closeBtn);
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const openShell = document.querySelector('[data-emc-player-shell]:not([hidden])');
      if (openShell) closeShell(openShell, { focusPlay: true });
    });
  })();

  (() => {
    const tracks = document.querySelectorAll('[data-emc-track]');
    if (!tracks.length) return;

    tracks.forEach((track) => {
      const section = track.closest('.electro-media-carousel');
      const prev = section?.querySelector('[data-emc-prev]');
      const next = section?.querySelector('[data-emc-next]');
      const dotsWrap = section?.querySelector('[data-emc-dots]');
      const counter = section?.querySelector('[data-emc-counter]');
      const origCards = Array.from(track.children);
      const origLen = origCards.length;
      if (origLen < 2) return;

      let dots = [];

      /* ---- Append clones for seamless infinite scroll ---- */
      origCards.forEach(card => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.classList.add('emc-clone');
        track.appendChild(clone);
      });

      const allCards = Array.from(track.children);

      /* ---- Dots (original count only) ---- */
      if (dotsWrap) {
        dotsWrap.innerHTML = '';
        origCards.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'electro-media-carousel__dot';
          dot.setAttribute('aria-label', `Go to media ${i + 1}`);
          dot.addEventListener('click', () => smoothTo(i));
          dotsWrap.appendChild(dot);
        });
        dots = Array.from(dotsWrap.children);
      }

      /* ---- Scroll helpers ---- */
      const smoothTo = (idx) => {
        const card = allCards[idx];
        if (!card) return;
        track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      };

      const jumpTo = (idx) => {
        const card = allCards[idx];
        if (!card) return;
        track.style.scrollSnapType = 'none';
        track.scrollLeft = card.offsetLeft - track.offsetLeft;
        requestAnimationFrame(() => { track.style.scrollSnapType = ''; });
      };

      const nearestIndex = () => {
        const left = track.scrollLeft;
        let nearest = 0, best = Infinity;
        allCards.forEach((card, i) => {
          const d = Math.abs(card.offsetLeft - track.offsetLeft - left);
          if (d < best) { best = d; nearest = i; }
        });
        return nearest;
      };

      const toOrig = (idx) => ((idx % origLen) + origLen) % origLen;

      const syncUI = () => {
        const cur = toOrig(nearestIndex());
        if (counter) counter.textContent = `${cur + 1} / ${origLen}`;
        dots.forEach((dot, i) => dot.setAttribute('aria-current', i === cur ? 'true' : 'false'));
      };

      /* ---- Active card states via IntersectionObserver ---- */
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              entry.target.setAttribute('data-active', entry.isIntersecting ? 'true' : 'false');
            });
          },
          { root: track, threshold: 0.55 }
        );
        allCards.forEach((card) => observer.observe(card));
      }

      /* ---- Snap back from clone zone after scroll settles ---- */
      const snapToReal = () => {
        const idx = nearestIndex();
        if (idx >= origLen) jumpTo(idx - origLen);
      };

      let scrollTimer;
      track.addEventListener('scroll', () => {
        syncUI();
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(snapToReal, 120);
      }, { passive: true });

      /* ---- Prev / Next (infinite) ---- */
      prev?.addEventListener('click', () => {
        const cur = nearestIndex();
        if (cur <= 0) {
          jumpTo(origLen);
          requestAnimationFrame(() => requestAnimationFrame(() => smoothTo(origLen - 1)));
        } else {
          smoothTo(cur - 1);
        }
      });

      next?.addEventListener('click', () => {
        smoothTo(nearestIndex() + 1);
      });

      /* ---- Keyboard navigation (infinite) ---- */
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          smoothTo(nearestIndex() + 1);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          const cur = nearestIndex();
          if (cur <= 0) {
            jumpTo(origLen);
            requestAnimationFrame(() => requestAnimationFrame(() => smoothTo(origLen - 1)));
          } else {
            smoothTo(cur - 1);
          }
        }
      });

      syncUI();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electro-tabbed-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const tabRoots = document.querySelectorAll('[data-etr-tabs]');
    if (!tabRoots.length) return;

    tabRoots.forEach((root) => {
      const tabs = [...root.querySelectorAll('[role="tab"]')];
      const panels = [...root.querySelectorAll('[role="tabpanel"]')];
      if (!tabs.length) return;

      const activate = (index) => {
        tabs.forEach((tab, i) => {
          const selected = i === index;
          tab.setAttribute('aria-selected', String(selected));
          tab.setAttribute('tabindex', selected ? '0' : '-1');
          panels[i]?.toggleAttribute('hidden', !selected);
        });
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(index));

        tab.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let target = index;

          if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') target = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') target = 0;
          if (event.key === 'End') target = tabs.length - 1;

          activate(target);
          tabs[target].focus();
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["electro-testimonial-cards"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const carousels = document.querySelectorAll('[data-etc-carousel]');
    if (!carousels.length) return;

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

    carousels.forEach((carousel) => {
      const track = carousel.querySelector('[data-etc-track]');
      if (!track) return;

      const origCards = Array.from(track.children);
      const origLen = origCards.length;
      if (origLen < 2) return;

      const prev = carousel.querySelector('[data-etc-prev]');
      const next = carousel.querySelector('[data-etc-next]');
      const dotsContainer = carousel.parentElement.querySelector('[data-etc-dots]');
      const counter = carousel.parentElement.querySelector('[data-etc-counter]');
      let dotButtons = [];

      /* ---- Append clones for seamless infinite scroll ---- */
      origCards.forEach(card => {
        const clone = card.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('id');
        clone.classList.add('etc-clone');
        track.appendChild(clone);
      });

      const allCards = Array.from(track.children);

      /* ---- Dots (original count only) ---- */
      if (dotsContainer) {
        dotsContainer.innerHTML = '';
        origCards.forEach((_, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'electro-testimonial-cards__dot';
          dot.setAttribute('aria-label', `Go to testimonial ${index + 1}`);
          dot.addEventListener('click', () => smoothTo(index));
          dotsContainer.appendChild(dot);
        });
        dotButtons = Array.from(dotsContainer.children);
      }

      /* ---- Scroll helpers ---- */
      const smoothTo = (idx) => {
        const card = allCards[idx];
        if (!card) return;
        track.scrollTo({ left: card.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      };

      const jumpTo = (idx) => {
        const card = allCards[idx];
        if (!card) return;
        track.style.scrollSnapType = 'none';
        track.scrollLeft = card.offsetLeft - track.offsetLeft;
        requestAnimationFrame(() => { track.style.scrollSnapType = ''; });
      };

      const nearestIndex = () => {
        const left = track.scrollLeft + 2;
        let nearest = 0, best = Infinity;
        allCards.forEach((card, i) => {
          const d = Math.abs(card.offsetLeft - track.offsetLeft - left);
          if (d < best) { best = d; nearest = i; }
        });
        return nearest;
      };

      const toOrig = (idx) => ((idx % origLen) + origLen) % origLen;

      const syncDots = () => {
        const cur = toOrig(nearestIndex());
        if (counter) counter.textContent = `${cur + 1} / ${origLen}`;
        dotButtons.forEach((dot, i) => {
          dot.setAttribute('aria-current', i === cur ? 'true' : 'false');
        });
      };

      /* ---- Snap back from clone zone after scroll settles ---- */
      const snapToReal = () => {
        if (isMobile()) return;
        const idx = nearestIndex();
        if (idx >= origLen) jumpTo(idx - origLen);
      };

      let scrollTimer;
      track.addEventListener('scroll', () => {
        syncDots();
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(snapToReal, 120);
      }, { passive: true });

      /* ---- Prev / Next (infinite) ---- */
      prev?.addEventListener('click', () => {
        const cur = nearestIndex();
        if (cur <= 0) {
          jumpTo(origLen);
          requestAnimationFrame(() => requestAnimationFrame(() => smoothTo(origLen - 1)));
        } else {
          smoothTo(cur - 1);
        }
      });

      next?.addEventListener('click', () => {
        smoothTo(nearestIndex() + 1);
      });

      /* ---- Autoplay ---- */
      let timer;
      const autoplayOn = carousel.dataset.autoplay === 'true';
      const interval = Number(carousel.dataset.interval || 5000);
      const stopAutoplay = () => { if (timer) clearInterval(timer); };

      const startAutoplay = () => {
        if (!autoplayOn || origLen < 2 || isMobile()) return;
        stopAutoplay();
        timer = setInterval(() => smoothTo(nearestIndex() + 1), interval);
      };

      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', startAutoplay);

      syncDots();
      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.electro-footer__newsletter-form').forEach((form) => {
      const field = form.querySelector('.electro-footer__newsletter-field');
      const input = form.querySelector('.electro-footer__newsletter-input');
      const submit = form.querySelector('.electro-footer__newsletter-submit');
      if (!field || !input || !submit) return;

      form.addEventListener('submit', async (e) => {
        e.preventDefault();

        if (!input.value || !input.validity.valid) {
          input.focus();
          field.setAttribute('data-state', 'error');
          setTimeout(() => field.removeAttribute('data-state'), 2500);
          return;
        }

        field.setAttribute('data-state', 'loading');
        submit.disabled = true;

        try {
          await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
          });

          field.setAttribute('data-state', 'success');
          input.value = '';

          setTimeout(() => {
            field.removeAttribute('data-state');
            submit.disabled = false;
          }, 3500);
        } catch {
          field.setAttribute('data-state', 'error');
          submit.disabled = false;

          setTimeout(() => {
            field.removeAttribute('data-state');
          }, 3000);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
